import React from 'react'
import Loader from 'app/components/mixins/Loader'

export default class ResolutionButton extends React.Component {
  constructor (props) {
    super(props)

    this.resolving = false

    this.state = {
      resolving: this.resolving
    }
  }

  static get defaultProps () {
    return {
      displayLoader: false
    }
  }

  get className () {
    return ''
  }

  get loader () {
    if (this.props.displayLoader === false) {
      return null
    }

    return <Loader small slow active />
  }

  get arrow () {
    return null
  }

  setAsResolved () {
    this.setState({ resolving: false }, () => {
      this.resolving = false
    })
  }

  resolve () {
    if (typeof (this.props.onResolve) !== 'function') {
      return
    }

    this.resolving = true

    this.setState({ resolving: true }, () => {
      this.props.onResolve()
        .then(() => {
          this.setAsResolved()
        })
        .catch((err) => {
          console.error('Caught error trying to resolve next action', err)
          this.setAsResolved()
        })
    })
  }

  onClick () {
    if (this.resolving === false) {
      return this.resolve()
    }
  }

  render () {
    const { displayArrow, label } = this.props

    const arrow = displayArrow ? this.arrow : null

    return (
      <>
        <button ref={ref => this.button = ref} disabled={this.state.resolving} onClick={this.onClick.bind(this)} type='button' className={this.className}>
          {label}
          {arrow}
          {(!this.state.resolving) ? null : this.loader}
        </button>
      </>
    )
  }
}
